import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-4" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("a", { class: "card-link" }, "My order didn't arrive", -1)
const _hoisted_5 = { class: "col-8" }
const _hoisted_6 = { class: "d-flex w-100 justify-content-between" }
const _hoisted_7 = { class: "mb-1" }
const _hoisted_8 = { class: "mb-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_b_card_title = _resolveComponent("b-card-title")!
  const _component_b_card_subtitle = _resolveComponent("b-card-subtitle")!
  const _component_b_card_text = _resolveComponent("b-card-text")!
  const _component_b_card = _resolveComponent("b-card")!
  const _component_b_avatar = _resolveComponent("b-avatar")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_b_list_group_item = _resolveComponent("b-list-group-item")!
  const _component_b_list_group = _resolveComponent("b-list-group")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_b_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_b_card, null, {
              default: _withCtx(() => [
                _createVNode(_component_b_card_title, null, {
                  default: _withCtx(() => [
                    _createTextVNode(" #" + _toDisplayString(_ctx.order.orderCode), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_b_card_subtitle, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.order.items.length) + " items ", 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_b_card_text, null, {
                  default: _withCtx(() => [
                    _createTextVNode(" $ " + _toDisplayString(_ctx.order.amount), 1)
                  ]),
                  _: 1
                }),
                _hoisted_4
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_b_list_group, null, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.order.items, (item) => {
              return (_openBlock(), _createBlock(_component_b_list_group_item, {
                key: item.product.id,
                class: "flex-column align-items-start"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("h5", _hoisted_7, [
                      _createVNode(_component_b_avatar, {
                        src: item.product.image
                      }, null, 8, ["src"]),
                      _createTextVNode(" " + _toDisplayString(item.product.name), 1)
                    ]),
                    _createElementVNode("small", null, _toDisplayString(item.product.price) + " x " + _toDisplayString(item.quantity) + " = $ " + _toDisplayString(item.product.price * item.quantity), 1)
                  ]),
                  _createElementVNode("p", _hoisted_8, _toDisplayString(item.product.description), 1),
                  _createElementVNode("small", null, [
                    _createElementVNode("a", null, [
                      _createVNode(_component_router_link, {
                        to: {name:'restorantdetails',params:{id:item.restorant.id}}
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.restorant.name), 1)
                        ]),
                        _: 2
                      }, 1032, ["to"])
                    ])
                  ])
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        })
      ])
    ])
  ]))
}